import { gql } from '@apollo/client';
import { insuranceFragment, hotelFragment } from 'store/fragments';

import { booking, leg, product, passenger } from '../queries/GET_BOOKING';

export default gql`
mutation confirmBooking(
  $bookingReference: String!,
  $sendConfirmationEmail: Boolean,
  $email: String,
  $isMissedDeparture: Boolean,
  $isFlowForwardCapped: Boolean,
  $language: String
) {
    confirmBooking(
      bookingReference: $bookingReference
      sendConfirmationEmail: $sendConfirmationEmail
      email: $email
      isMissedDeparture: $isMissedDeparture
      isFlowForwardCapped: $isFlowForwardCapped
      language: $language
    ) {
      reference

      ${booking}
    }
  }

  ${insuranceFragment}

  ${hotelFragment}

  ${leg}

  ${passenger}

  ${product}
`;
